import { create } from "zustand";
const useConciergePendingQuery = create(
  (set) => ({
    pendingQuery: null,
    pendingStacklineSku: null,
    pendingQueryId: null,
    setPendingQuery: (query, stacklineSku) => set({
      pendingQuery: query,
      pendingStacklineSku: stacklineSku,
      // Generate a unique ID for this query request
      pendingQueryId: `${Date.now()}-${Math.random().toString(36).slice(2)}`
    }),
    clearPendingQuery: () => set({ pendingQuery: null, pendingStacklineSku: null, pendingQueryId: null })
  })
);
export {
  useConciergePendingQuery
};
//# sourceMappingURL=useConciergePendingQuery.js.map
